import React, { useState, useEffect } from "react";
import Login from "./auth/Login";
import Password from "./auth/Password";
import Admin from "./routes/admin";
import NavBar from "./components/navBar";
import Editor from "./components/Editor";
import DBEditor from "./routes/edit";
import Notepad from "./routes/notepad";
import TransitionCare from "./routes/transitionCare";
import Home from "./routes/home";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { RequireAuth, AuthProvider } from "react-auth-kit";
import 'bootstrap/dist/css/bootstrap.min.css';

// Functions to get and set cookies
const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for(let i=0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const setCookie = (name, value, days = 365) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
};

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('darkMode') === 'true';
  });

  const [selectedModel, setSelectedModel] = useState(() => {
    const storedModel = getCookie('selectedModel');
    const supportedModels = ['gpt-5.4-mini', 'gpt-5.4', 'gpt-5.6-luna', 'gpt-5.6-terra'];
    return supportedModels.includes(storedModel) ? storedModel : 'gpt-5.6-luna';
  });

  const handleModelChange = (model) => {
    setSelectedModel(model);
    setCookie('selectedModel', model);
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  return (
    <AuthProvider authType = {'cookie'}
      authName={'_auth'}
      cookieDomain={window.location.hostname}
      cookieSecure={window.location.protocol === "https:"}>
        <BrowserRouter>
            <Routes>
                  <Route path="/login" element={<Login/>} />
                  <Route path={'/'} element={<Home/>} />
                  <Route path={'/app'} element={
                    <RequireAuth loginPath={'/login'}>
                        <NavBar darkMode={darkMode} setDarkMode={setDarkMode} selectedModel={selectedModel} onChangeModel={handleModelChange} />
                        <Editor selectedModel={selectedModel} />
                    </RequireAuth>
                  }/>
                  <Route path={'/transition-care'} element={
                    <RequireAuth loginPath={'/login'}>
                      <NavBar subname="Pós-alta" darkMode={darkMode} setDarkMode={setDarkMode} selectedModel={selectedModel} onChangeModel={handleModelChange} />
                      <TransitionCare/>
                    </RequireAuth>
                  }/>
                  <Route path={'/admin'} element={
                    <RequireAuth loginPath={'/login'}>
                      <NavBar subname="Painel Admin" darkMode={darkMode} setDarkMode={setDarkMode} selectedModel={selectedModel} onChangeModel={handleModelChange} />
                      <Admin/>
                    </RequireAuth>
                  }/>
                  <Route path={'/edit/models'} element={
                    <RequireAuth loginPath={'/login'}>
                      <NavBar subname="Editor de modelos" darkMode={darkMode} setDarkMode={setDarkMode} selectedModel={selectedModel} onChangeModel={handleModelChange} />
                      <DBEditor type="models"/>
                    </RequireAuth>
                  }/>
                  <Route path={'/edit/templates'} element={
                    <RequireAuth loginPath={'/login'}>
                      <NavBar subname="Editor de templates" darkMode={darkMode} setDarkMode={setDarkMode} selectedModel={selectedModel} onChangeModel={handleModelChange} />
                      <DBEditor type="templates"/>
                    </RequireAuth>
                  }/>
                  <Route path={'/notepad'} element={
                    <RequireAuth loginPath={'/login'}>
                      <NavBar subname="Notepad" darkMode={darkMode} setDarkMode={setDarkMode} selectedModel={selectedModel} onChangeModel={handleModelChange} />
                      <Notepad/>
                    </RequireAuth>
                  }/>
                  <Route path={'/change-password'} element={
                    <RequireAuth loginPath={'/login'}>
                      <NavBar darkMode={darkMode} setDarkMode={setDarkMode} selectedModel={selectedModel} onChangeModel={handleModelChange} />
                      <Password/>
                    </RequireAuth>
                  }/>
            </Routes>
        </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
